import axios from 'axios';

function sendResetEmail (email) {
  return axios.post('api/forgotPassword', {email: email});
}

function resetPassword (newPassword, token) {
  if (newPassword && token) {
    return axios.post('api/resetPassword', {token: token, password: newPassword});
  }
}

function signInUserToken (token) {
  var timezoneOffsetMinutes = new Date().getTimezoneOffset();
  timezoneOffsetMinutes = timezoneOffsetMinutes === 0 ? 0 : -timezoneOffsetMinutes;
  return axios.post('api/loginByToken', {
    token: token,
    timezoneOffsetMinutes: timezoneOffsetMinutes
  });
}

function signIn (email, password) {
  var timezoneOffsetMinutes = new Date().getTimezoneOffset();
  timezoneOffsetMinutes = timezoneOffsetMinutes === 0 ? 0 : -timezoneOffsetMinutes;
  return axios.post('api/login', {
    email: email,
    password: password,
    timezoneOffsetMinutes: timezoneOffsetMinutes
  });
}

function validatePasswordResetToken (token) {
  return axios.post('api/validatePasswordResetToken', {token: token});
}

function logout (userId) {
  localStorage.access_token = 0;
  return axios.post('api/logout', {userId: userId});
}

function maintenanceAction (flag) {
  return axios.post('api/maintenance', {flag: flag});
}

function sendOtp (flag) {
  return axios.post('api/sendOtpOnMail', {flag: flag});
}

function SendOtpService (inputOtp) {
  return axios.post('api/checkOtpActive', {inputOtp: inputOtp});
}

function maintenanceFlag () {
  return axios.get('api/getmaintenanceflag');
}

function maintenanceFlagForIP () {
  return axios.get('api/maintenanceFlagForIP');
}

export {
  sendResetEmail,
  resetPassword,
  signIn,
  validatePasswordResetToken,
  logout,
  maintenanceAction,
  maintenanceFlag,
  maintenanceFlagForIP,
  sendOtp,
  SendOtpService,
  signInUserToken
};



// WEBPACK FOOTER //
// ./src/services/LoginService.js